import Header from "../components/Header";
import About from "../components/About";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

function HomePage() {
  return (
    <>
      <Header />

      <main className="relative z-10 pt-20 md:pt-24 pb-16">
        <About />

        <Projects />

        <section className="max-w-5xl mx-4 md:mx-auto mt-8 md:mt-12">
          <div className="glass-card p-6 md:p-8 text-slate-800 leading-relaxed text-left">
            <h3 className="text-2xl md:text-3xl font-extrabold mb-4 text-slate-900">
              Warum Prozessdigitalisierung jetzt entscheidend ist
            </h3>
            <p className="text-base md:text-lg">
              Viele kleine und mittelständische Unternehmen verlieren weiterhin wertvolle Zeit durch Papierabläufe,
              unübersichtliche Excel-Listen und manuelle Routinen. Moderne, digitale Prozessstrukturen schaffen
              Transparenz, reduzieren Fehler und erhöhen die Geschwindigkeit im Tagesgeschäft deutlich.
            </p>
            <p className="text-base md:text-lg mt-4">
              Ob interne Webanwendung oder optimierte Excel-Lösung: Das Ziel ist immer derselbe Effekt:
              Mehr Fokus auf das eigentliche Geschäft.
            </p>
          </div>
        </section>

        <Contact />
      </main>

      <Footer />
    </>
  );
}

export default HomePage;
